// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-text[data-v-45dbedb0] {\n  font-family: \"PingFang SC\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.title-text[data-v-45dbedb0]  img {\n  vertical-align: text-bottom;\n}\n", ""]);
// Exports
module.exports = exports;
